import TokenCredentialFields from './components/TokenCredentialFields.vue';
import LoginPasswordCredentialFields from './components/LoginPasswordCredentialFields.vue';
import LoginPasswordDomainCredentialFields from './components/LoginPasswordDomainCredentialFields.vue';
import WoocommerceCredentialFields from './components/WoocommerceCredentialFields.vue';
import IntelTeleCredentialFields from './components/IntelTeleCredentialFields.vue';
import RozetkaCredentialFields from './components/RozetkaCredentialFields.vue';
import NovapostCredentialFields from './components/NovapostCredentialFields.vue';

import { ApiCredentialsServiceEnum } from '../../../enums/ApiCredentialsServiceEnum';

export const apiCredentialServiceComponents = {
    [ApiCredentialsServiceEnum.EVA]: LoginPasswordCredentialFields,
    [ApiCredentialsServiceEnum.ALLO]: LoginPasswordCredentialFields,
    [ApiCredentialsServiceEnum.EPICENTR]: TokenCredentialFields,
    [ApiCredentialsServiceEnum.KASTA]: TokenCredentialFields,
    [ApiCredentialsServiceEnum.HOROSHOP]: LoginPasswordDomainCredentialFields,
    [ApiCredentialsServiceEnum.SHOP_EXPRESS]: LoginPasswordDomainCredentialFields,
    [ApiCredentialsServiceEnum.ROZETKA]: RozetkaCredentialFields,
    [ApiCredentialsServiceEnum.PROM]: TokenCredentialFields,
    [ApiCredentialsServiceEnum.WOOCOMMERCE]: WoocommerceCredentialFields,
    [ApiCredentialsServiceEnum.MAUDAU]: LoginPasswordCredentialFields,
    [ApiCredentialsServiceEnum.INTEL_TELE]: IntelTeleCredentialFields,
    [ApiCredentialsServiceEnum.NOVAPOST]: NovapostCredentialFields
};
